import {
  ProductImage,
  productImageFromResponse,
} from '../Product/ProductImage';
import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from '../Product/ProductPriceInfo';

export interface WishlistProduct {
  id: number;
  slug: string;
  name: string;
  qty: number;
  baseImage: ProductImage;
  price: ProductPriceInfo;
  specialPrice?: ProductPriceInfo;
}

export const wishlistProductFromResponse = (
  responseData: any,
): WishlistProduct => ({
  id: responseData.id,
  slug: responseData.slug,
  name: responseData.name,
  qty: responseData.qty,
  baseImage: productImageFromResponse(responseData.base_image),
  price: productPriceInfoFromResponse(responseData.price),
  specialPrice: responseData.special_price
    ? productPriceInfoFromResponse(responseData.special_price)
    : undefined,
});
